export default __webpack_public_path__ + "static/media/FakeWestern.c27fce74.png";